import type { IToolbarItem, ToolbarButtonRenderers } from './../../../ricos-types';

import { defaultToolbarItemsRenderers } from '../../default-toolbar-renderers';
import { ToolbarButton } from '../../models';

export const transformItemToButton = (
  toolbarItem: IToolbarItem,
  itemRenderers: ToolbarButtonRenderers
) => {
  const toolbarItemRender = getToolbarItemRender(toolbarItem, itemRenderers);

  if (!toolbarItemRender) {
    throw new Error(`Toolbar: missing toolbar item renderer for '${toolbarItem.id}'`);
  }

  const toolbarItemRenderElement = toolbarItemRender(toolbarItem);
  return new ToolbarButton(toolbarItem, toolbarItemRenderElement);
};

const getToolbarItemRender = (toolbarItem: IToolbarItem, itemRenderers: ToolbarButtonRenderers) => {
  const allRenders = {
    ...defaultToolbarItemsRenderers,
    ...itemRenderers,
  } as ToolbarButtonRenderers;
  const toolbarItemRender = allRenders[toolbarItem.id];

  if (!toolbarItemRender) {
    if (toolbarItem.presentation?.component) {
      return allRenders.custom;
    }
    return allRenders.default;
  }

  return toolbarItemRender;
};
